// Filter Component Constants

// Filter text constants
export const FILTER_TEXT_RESET_FILTER = "Reset Filter";
export const FILTER_TEXT_APPLY = "Apply";
export const FILTER_TEXT_CANCEL = "Cancel";
export const FILTER_TEXT_SEARCH_PREFIX = "Search ";
export const FILTER_TEXT_SITES = "Sites";

// Filter tab names
export const FILTER_TAB_LOCATION = "Location";
export const FILTER_TAB_LOCATION_LOWERCASE = "location";

// Page identifiers
export const PAGE_IDENTIFIER_CAMERAS_TAB = "CamerasTab";
export const PAGE_IDENTIFIER_COMPANION_TAB = "CompanionTab";
export const PAGE_IDENTIFIER_ALERTS = "Alerts";
export const PAGE_IDENTIFIER_EVENTS = "Events";

// Color constants
export const COLOR_ACTIVE_TAB_BG = "#F6F6F6";
export const COLOR_TRANSPARENT = "transparent";
export const COLOR_CHECKBOX_BORDER = "#6F7171";
